import { render } from "./student-referral-modal.vue?vue&type=template&id=caad11de"
import script from "./student-referral-modal.vue?vue&type=script&lang=js"
export * from "./student-referral-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__